import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { mergeAriaIds } from '../../../lib/aria';
import { cn } from '../../../lib/utils';
import { SpecraCheckbox } from '../ensigns/checkbox';
/** Checkbox plus its visible label and optional supporting description. */ export function SpecraCheckboxField({ className, controlProps, description, label, ...props }) {
    const generatedId = React.useId();
    const id = controlProps?.id ?? generatedId;
    const descriptionId = description ? `${id}-description` : undefined;
    const describedBy = mergeAriaIds(controlProps?.['aria-describedby'], descriptionId);
    return /*#__PURE__*/ _jsxs("label", {
        className: cn('inline-flex items-start gap-[var(--space-ui-gap)] text-[length:var(--fs-ui-title)] text-foreground has-[:disabled]:cursor-not-allowed has-[:disabled]:opacity-50', className),
        htmlFor: id,
        ...props,
        children: [
            /*#__PURE__*/ _jsx(SpecraCheckbox, {
                ...controlProps,
                "aria-describedby": describedBy,
                className: cn('mt-[var(--space-0-5)]', controlProps?.className),
                id: id
            }),
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "block",
                        children: label
                    }),
                    description ? /*#__PURE__*/ _jsx("span", {
                        className: "mt-[var(--space-0-5)] block text-[length:var(--fs-ui-caption)] text-muted-foreground",
                        id: descriptionId,
                        children: description
                    }) : null
                ]
            })
        ]
    });
}
